<template>

    <div id="signin-outer-wrapper">

        <div class="loading-screen" v-if=" currentMerchant == null ">

            Loading...
        </div>
        <div v-else style="height: 100%">

            <font-awesome-icon v-if=" this.sentCode " class="back-button" icon="arrow-left" @click=" revertCode() "/>

            <div class="signin-inner-wrapper">

                <div>

                    <div v-if=" !this.sentCode">

                        <p class="signin-title">What is your phone number?</p>
                        <p :class=" signinSubtitleClass ">We'll text a code to verify your phone</p>
                    </div>
                    <div v-else>

                        <p class="signin-title">Look at your text messages<br>Enter Your Code</p>
                        <p :class=" revertCodeSubtitleClass " @click=" revertCode() ">click here to go back and try again</p>
                    </div>

                    <div class="number-input-wrapper" v-if=" !this.sentCode ">

                        <p class="formatted-number" :style="{ color : this.countryCode == 1 ? 'black' : 'red' }">{{ formattedPhone }}</p>
                        <vue-tel-input
                            v-model=" phone "
                            @onInput=" onInput "
                            :preferredCountries="[ 'us', 'mx', 'gb' ]"
                            :placeholder=" 'Phone Number' "
                        >
                        </vue-tel-input>
                        <p class="auth-error">{{ authError }}</p>

                        <h3 v-if=" environment != 'Production' " style="text-align:center; margin: 0px 0px 10px;"> {{ currentMerchant.name }}</h3>
                        <h5 v-if=" environment != 'Production' " style="text-align:center; margin: 0;"> Environment: {{ environment }} </h5>
                        <p v-if=" environment != 'Production' " style="text-align:center; margin: 5px 0px 0px; color: #777">*this does not appear on production</p>
                    </div>
                    <div class="number-input-wrapper" v-else>

                        <input class="code-input" type="number" placeholder="enter code.." v-model=" textCode "/>
                        <p class="auth-error">{{ authError }}</p>
                    </div>


                </div>
                <div class="input-button-wrapper">

                    <!-- <p class="new-number-prompt">Have an account and a new number?</p> -->

                    <button type="button" :class=" NextButtonClass " @click=" sentCode ? submitCode() : submitPhone() ">Next</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import KeyPad from './misc/KeyPad';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'signin',
        data () {

            return {

                phone       : '',
                countryCode : 1,
                isValid     : false,
                textCode    : '',
                env         : process.env.VUE_APP_ENVIRONMENT
            }
        },
        methods: {

            onInput( { number, isValid, country } ) {

                if( this.countryCode != country.dialCode ) this.countryCode = country.dialCode;
                this.isValid = isValid;
            },
            submitPhone(){

                if( this.countryCode != 1 || !this.isValid ){

                    this.$store.dispatch( 'auth/setAuthError', 'please enter a valid phone number' );
                } else {

                    this.$store.dispatch( 'auth/setAuthError', '' );
                    const data = {

                        phone: this.formattedPhone.replace( /[\s()-]/g, "" ).substr( 2 )
                    };
                    this.$store.dispatch( 'auth/phoneSignin', data );
                }
            },
            submitCode(){

                if( this.textCode.length != 6 ){

                    this.$store.dispatch( 'auth/setAuthError', 'please enter 6 digits' );
                } else {

                    this.$store.dispatch( 'auth/setAuthError', '' );
                    const data = {

                        code  : this.textCode,
                        phone : JSON.parse( localStorage.getItem( 'tempPhone' ) ) || null
                    };
                    this.$store.dispatch( 'auth/checkCode', data );
                }
            },
            detectKey( e ){

                if( e.keyCode == 13 ){

                    this.sentCode ? this.submitCode() : this.submitPhone();
                }
            },
            revertCode(){

                this.$store.dispatch( 'auth/revertCode' );
            },
            sanitizeString( str ){

                str = str.replace( /[^a-z0-9 \.,_-]/gim, "" );
                return str.trim();
            }
        },
        computed: {

            ...mapGetters({

                authError       : 'auth/authError',
                sentCode        : 'auth/sentCode',
                currentPosition : 'keypad/currentPosition',
                currentMerchant : 'merchant/currentMerchant',
                currentLocation : 'merchant/currentLocation',
                merchantIdCrocante  : 'merchantIdCrocante',
            }),
            formattedPhone: function(){

                if( this.countryCode == 1 ){
                    let raw = ( this.isValid && this.phone.length == 15 ) ? this.phone.replace( /\s/g, "" ).substr( 2 ) : ( this.phone.substr( 0, 2 ) == '+1' ) ? this.phone.replace( /\s/g, "" ).substr( 2, 10 ) : this.phone.substr( 0, 10 );
                    let formatting = [];
                    for( let i = 0; i < raw.length; i++ ){

                        switch( i ){

                            case 0:
                                formatting[ i ] = '( ' + raw[ i ];
                                break;
                            case 1:
                                formatting[ i ] = raw[ i ];
                                break;
                            case 2:
                                formatting[ i ] = raw[ i ] + ' ) ';
                                break;
                            case 3:
                            case 4:
                                formatting[ i ] = raw[ i ];
                                break;
                            case 5:
                                formatting[ i ] = raw[ i ] + ' - ';
                                break;
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                                formatting[ i ] = raw[ i ];
                                break;
                            default:
                                break;
                        }
                    }
                    return '+' + this.countryCode + ' ' + formatting.join( '' );
                } else return 'we are only accepting US at this time';
            },
            revertCodeSubtitleClass(){
                const base = [ 'revert-code-subtitle' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'crocante-revert-code-subtitle' : 'xo-revert-code-subtitle' )
                return base.join( ' ' );
            },
            signinSubtitleClass(){
                const base = [ 'signin-subtitle' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'crocante-subtitle' : 'xo-subtitle' )
                return base.join( ' ' );
            },
            NextButtonClass(){

                const base = [ 'next-button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'button btn-brown' : 'button btn-green' )
                return base.join( ' ' );
            },
            environment(){

                return process.env.VUE_APP_ENVIRONMENT
            }
        },
        created() {

            window.addEventListener( 'keypress', this.detectKey );
            const url = this.$route.path.split( '/' );
            const slug = url[ 2 ];
            console.log( 'slug: ', slug );

            if( this.currentMerchant == null ){
                // changing slug manually automatically will clear state and send the user right here with this condition already met

                this.$store.dispatch( 'merchant/identifyBySlug', slug );
            }
        },
        destroyed(){

            window.removeEventListener( 'keypress', this.detectKey );
        },
        components: {

            KeyPad,
            FontAwesomeIcon
        }
    }

</script>

<style scoped>

    #signin-outer-wrapper {

        height: 100%;
        margin: auto;
        z-index: 450;
    }
    .back-button {

        position: absolute;
        top: 25px;
        left: 15px;
    }
    .signin-inner-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        width: 100%;
        height: 100%;
        padding: 55px 0px 1px;
    }

    .loading-screen {

        text-align: center;
        color: #666;
        margin-top: 210px;
        font-size: 1.3rem;
        letter-spacing: 10px;
    }

    .signin-title {

        text-align: center;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .signin-subtitle {

        text-align: center;
        font-size: 16px;
    }

    .crocante-subtitle {

        color: #4A2612;
    }

    .xo-subtitle {

        color: #569935;
    }
    .revert-code-subtitle {

        font-weight: bold;
        font-size: 16px;
        text-align: center;
    }

    .xo-revert-code-subtitle {
        color: #569935;
    }

    .crocante-revert-code-subtitle {
        color: #4A2612;
    }

    .number-input-wrapper {

        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        flex: 1;
        padding-top: 75px;

        margin: 0px 10px;
    }

    .formatted-number {

        margin: 0px 25px 25px;
        font-weight: bold;
        font-size: 22px;
        text-align: center;
    }

    .input-button-wrapper {

        width: 100%;
    }
    .next-button {

        width: 100%;
        height: 55px;
        border-radius: 0;
    }

    .new-number-prompt {

        text-align: center;
        color: #569935;
        margin: 20px 0;
        font-size: 1.1rem;
    }

    .code-input {

        background-color: transparent;
        height: 45px;
        border-bottom: 1px solid #ccc;
        text-align: center;
        width: 100%;
    }

    .auth-error {

        color: red;
        text-align: center;
        padding: 20px 0px 0px;
        font-size: 16px;
    }

    input{

        height: 25px;
        border-radius: 5px;
        outline: none;
        border: none;
        background-color: #d1caca;
        padding: 2px 10px;
        font-weight: 600;
        font-size: 1.1rem;
        box-sizing: border-box;
        border: 0px solid transparent;
        box-shadow: none;
        transition: border 0.6s, box-shadow 0.6s;
    }
    input:focus{

        box-shadow: 0px 1px 0px 0px #f0f7fa;
        border: 1px solid #057fd0;
    }
</style>